module.exports = __webpack_public_path__ + "img/u52.aaa3e4a0.jpg";